import { Container, Row, Col } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import TrackVisibility from "react-on-screen";

export const Blog = () => {
  const blogs = [
    {
      category: "React",
      date: "May 10, 2025",
      title: "How I Built My First Full-Stack App with React & Node.js",
      description:
        "A step-by-step journey of building a complete web application from scratch — frontend, backend, database and deployment.",
      readTime: "5 min read",
      color: "#61dafb",
      link: "#",
    },
    {
      category: "CSS",
      date: "April 22, 2025",
      title: "10 CSS Tricks Every Web Developer Should Know",
      description:
        "From custom scroll bars to glass morphism effects — these CSS tips will level up your UI design skills instantly.",
      readTime: "4 min read",
      color: "#264de4",
      link: "#",
    },
    {
      category: "JavaScript",
      date: "March 15, 2025",
      title: "Understanding Async/Await in JavaScript the Easy Way",
      description:
        "Callbacks, Promises, Async/Await — I explain the whole async JavaScript journey in a beginner-friendly way.",
      readTime: "6 min read",
      color: "#f7df1e",
      link: "#",
    },
    {
      category: "MongoDB",
      date: "February 28, 2025",
      title: "Getting Started with MongoDB and Express REST API",
      description:
        "Learn how to set up a MongoDB database and build a full REST API with Express.js from zero to deployment.",
      readTime: "7 min read",
      color: "#47a248",
      link: "#",
    },
    {
      category: "Tips",
      date: "January 18, 2025",
      title: "My Top 5 VS Code Extensions for Web Developers",
      description:
        "These extensions have saved me hours of work. From auto-formatting to Git integration — must-have tools for 2025.",
      readTime: "3 min read",
      color: "#007acc",
      link: "#",
    },
    {
      category: "Career",
      date: "December 5, 2024",
      title: "How I Started Learning Web Development from Zero",
      description:
        "My honest story of starting web development as a CSE student — the resources I used, mistakes I made, and lessons learned.",
      readTime: "8 min read",
      color: "#7b2ff7",
      link: "#",
    },
  ];

  return (
    <section className="blog-section" id="blog">
      <Container>
        <TrackVisibility>
          {({ isVisible }) => (
            <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
              <div className="blog-title">
                <h2>Latest <span>Blogs</span></h2>
                <p>Sharing what I learn — web development tips, project breakdowns & coding experiences.</p>
              </div>

              <Row>
                {blogs.map((blog, idx) => (
                  <Col key={idx} xs={12} md={6} lg={4} className="mb-4">
                    <a href={blog.link} className="blog-card-link" target="_blank" rel="noopener noreferrer">
                      <div className="blog-card" style={{ "--card-color": blog.color }}>
                        <div className="blog-card-top">
                          <span className="blog-category" style={{ color: blog.color, borderColor: blog.color + "44", background: blog.color + "15" }}>
                            {blog.category}
                          </span>
                          <span className="blog-readtime">{blog.readTime}</span>
                        </div>
                        <h4 className="blog-card-title">{blog.title}</h4>
                        <p className="blog-card-desc">{blog.description}</p>
                        <div className="blog-card-footer">
                          <span className="blog-date">{blog.date}</span>
                          <span className="blog-read-more">Read More <ArrowRightCircle size={16} /></span>
                        </div>
                        <div className="blog-card-glow" style={{ background: blog.color }} />
                      </div>
                    </a>
                  </Col>
                ))}
              </Row>
            </div>
          )}
        </TrackVisibility>
      </Container>
    </section>
  );
};
